import React from "react";
import "./SubtleSeparator.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";

export interface SubtleSeparatorProps {
  verticalMargin?: number;
  text?: React.ReactNode;
}

export default function SubtleSeparator(incomingProps: SubtleSeparatorProps) {
  const props = withDefaults(incomingProps, subtleSeparatorDefaultProps);

  return (
    <div
      className="subtle-separator"
      style={{ margin: `${props.verticalMargin}px 0px` }}
    >
      <span className={classNames("divider", "first")} />
      <span>{props.text}</span>
      <span className={classNames("divider", "last")} />
    </div>
  );
}

const subtleSeparatorDefaultProps = {
  verticalMargin: 0,
  text: "OR"
};
